import React, { useState } from 'react';
import { useDataProvider, useNotify, useRefresh } from 'react-admin';

import { Button, makeStyles } from '@material-ui/core';

import { UserDetails } from '../types';

const useStyles = makeStyles((theme) => ({
  button: {
    textTransform: 'none',
    color: theme.palette.secondary.contrastText,
  },
}));

interface Props {
  user: UserDetails;
}

const BypassFraudButton = ({ user }: Props) => {
  const { id: rolloId, cognitoUserId: cognitoId, fraudAllowedAt: bypassFraud } = user;

  const classes = useStyles();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const [loading, setLoading] = useState<boolean>(false);

  const handleClick = async () => {
    try {
      setLoading(true);

      await dataProvider.post('bypassFraud', {
        data: {
          bypass: !bypassFraud,
          rolloId,
          cognitoId,
        },
      });

      refresh();
    } catch (error: any) {
      notify(
        typeof error === 'string' ? error : error.message || 'ra.notification.http_error',
        'warning'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outlined" onClick={handleClick} disabled={loading} className={classes.button}>
      {!bypassFraud ? 'Add to fraud bypass list' : 'Remove from fraud bypass list'}
    </Button>
  );
};

export default BypassFraudButton;
